<div class="country-detail-modal">
    <header class="country-detail-modal__header">
        <img class="country-detail-modal__image" [src]="country.icono" [alt]="country.nombre">
        <div class="country-detail-modal__info">
            <h2 class="country-detail-modal__title">{{ country.nombre }}</h2>
            <p class="country-detail-modal__population">Población: {{ country.poblacion | number }}</p>
        </div>
    </header>

    <div class="country-detail-modal__content">
        <p class="country-detail-modal__description">
            {{country.descripcion}}
        </p>

        <div class="country-detail-modal__courses">
            <h3 class="country-detail-modal__courses-title">Tipos de Cursos Populares:</h3>
            <ul class="country-detail-modal__courses-list">
                <li *ngFor="let course of country.tiposCursosPopulares" class="country-detail-modal__courses-item">
                    <span class="country-detail-modal__courses-item--bold">{{ course.nombre }}: </span>
                    <span>{{ course.notas }}</span>
                </li>
            </ul>
        </div>

        <p class="country-detail-modal__description">
            <span class="country-detail-modal__description--bold">Perfil Estudiante:</span> {{ country.perfilEstudiante }}
        </p>

        <p class="country-detail-modal__description">
            <span class="country-detail-modal__description--bold">Costo Vida Idiomas 6 Meses:</span>
            {{ country.costoMatriculaIdioma ? (country.costoMatriculaIdioma | number) : 'N/A' }} {{country.costoMatriculaIdioma ? country.moneda : ''}}
        </p>
        <p class="country-detail-modal__description">
            <span class="country-detail-modal__description--bold">Costo Educación Pública Promedio:</span>
            {{ country.costoEducacionPublica.min | number }} {{country.moneda}} - {{ country.costoEducacionPublica.max | number }} {{country.moneda}}
        </p>
        <p class="country-detail-modal__description">
            <span class="country-detail-modal__description--bold">Costo Educación Privada Promedio:</span>
            {{ country.costoEducacionPrivada.min | number }} {{country.moneda}} - {{ country.costoEducacionPrivada.max | number }} {{country.moneda}}
        </p>
        <p class="country-detail-modal__description">
            <span class="country-detail-modal__description--bold">Costo de Vida Estudiantil Promedio:</span>
            {{ country.costoVidaMensual.min | number }} {{country.moneda}} - {{ country.costoVidaMensual.max | number }} {{country.moneda}}
        </p>
        <p class="country-detail-modal__description">
            <span class="country-detail-modal__description--bold">Industrias Fuertes:</span> {{ country.industriasFuertes.join(', ') }}
        </p>
        <p class="country-detail-modal__description">
            <span class="country-detail-modal__description--bold">Permiso Trabajo Postgraduacion:</span> {{ country.permisoTrabajoPostgraduacion }}
        </p>

        <p class="country-detail-modal__description">
            <span class="country-detail-modal__description--bold">Costo Promedio Anual COP:</span>
            {{ country.costoPromedioAnualCOP.min | number }} - {{ country.costoPromedioAnualCOP.max | number }} {{country.moneda}}
        </p>
    </div>
</div>
